const { pink100 } = require('material-ui/styles/colors')

const getMuiTheme = require('material-ui/styles').getMuiTheme
// call this function to prefix styles for tops:
const prepareStyles = getMuiTheme().prepareStyles

function genBasicStyles({
  isNegative = false,
  isTops = false,
  pillWidth = '180px',
  isCustom = false,
} = {}) {
  const common = {
    span: {
      fontWeight: 'bold',
      fontSize: '70%',
    },
    plusOneButton: {
      height: '24px',
      width: '24px',
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      [isNegative ? 'left' : 'right']: 0,
    },
  }

  const containerStyles = {
    custom: {
      width: '100%',
      height: '60px',
      position: 'relative',
      margin: '72px 0 50px',
      display: 'flex',
      alignItems: 'center',
    },
    default: {
      width: '100%',
      height: '60px',
      position: 'relative',
      margin: '50px 0',
      display: 'flex',
      alignItems: 'center',
    },
  }

  if (!isTops) {
    return {
      ...common,
      outerContainer: {
        // no op, just matching tops keys
      },
      innerContainer: isCustom
        ? containerStyles.custom
        : containerStyles.default,
      pill: {
        zIndex: '100',
        backgroundColor: '#ebebeb',
        height: '40%',
        width: pillWidth,
        padding: '5px',
        left: 0,
        borderRadius: '500px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
      },
      numberLine: {
        position: 'absolute',
        leftFill: '#90CAF9',
        rightFill: '#9FA8DA',
      },
    }
  }
  // TODO: consider using `box-sizing: border-box` to enforce 1000px width.
  // need that width so number line works properly
  return {
    ...common,
    outerContainer: {
      border: '2px solid white',
      backgroundColor: '#dee1cb',
      borderRadius: '5px',
      margin: '5px 0',
    },
    innerContainer: prepareStyles({
      width: '100%',
      height: '60px',
      position: 'relative',
      margin: '20px 0',
      display: 'flex',
      alignItems: 'center',
    }),
    pill: prepareStyles({
      zIndex: '100',
      background: 'linear-gradient(#63aef8, #1672fb)',
      height: '40%',
      width: pillWidth,
      padding: '5px',
      borderRadius: '500px',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      color: 'white',
    }),
    numberLine: {
      position: 'absolute',
      top: 'calc(50%)',
      left: '0px',
      transform: 'translateY(-25%)',
      leftFill: '#555555',
      rightFill: '#929292',
    },
  }
}

function genNumberLineStyles({
  color,
  isNegative = false,
  isTops = false,
} = {}) {
  const scaleContainer = {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    height: '20px',
  }

  if (!isTops) {
    return {
      scaleContainer,
      hour1: {
        color,
        fontWeight: 'bold',
        position: 'relative',
        fontSize: '0.7em',
        right: isNegative ? '-672px' : '-6px',
        float: 'left',
      },
      hour7: {
        color,
        fontWeight: 'bold',
        position: 'relative',
        fontSize: '0.7em',
        right: isNegative ? '-575px' : '-106px',
        float: 'left',
      },
      day1: {
        color,
        fontWeight: 'bold',
        position: 'relative',
        fontSize: '0.7em',
        right: isNegative ? '-568px' : '-112px',
        bottom: 0,
        float: 'left',
      },
      day15: {
        color,
        fontWeight: 'bold',
        position: 'relative',
        fontSize: '0.7em',
        right: isNegative ? '-296px' : '-386px',
        bottom: 0,
        float: 'left',
      },
      day30: {
        color,
        fontWeight: 'bold',
        position: 'relative',
        fontSize: '0.7em',
        right: isNegative ? '-8px' : '-673px',
        bottom: 0,
        float: 'left',
      },
    }
  }
  return {
    scaleContainer,
    hour1: {
      color: '#555555',
      fontWeight: 'bold',
      position: 'absolute',
      fontSize: '11px',
      left: '9px',
      bottom: '5px',
      float: 'left',
    },
    hour7: {
      color: '#555555',
      fontWeight: 'bold',
      position: 'absolute',
      fontSize: '11px',
      left: '138px',
      bottom: '5px',
      float: 'left',
    },
    day1: {
      color: '#555555',
      fontWeight: 'bold',
      position: 'absolute',
      fontSize: '11px',
      left: '188px',
      bottom: '5px',
      float: 'left',
    },
    day15: {
      color: '#555555',
      fontWeight: 'bold',
      position: 'absolute',
      fontSize: '11px',
      right: '330px',
      bottom: '5px',
      float: 'left',
    },
    day30: {
      color: '#555555',
      fontWeight: 'bold',
      position: 'absolute',
      fontSize: '11px',
      right: '20px', // lands between 29 & 30 days!
      bottom: '5px',
      float: 'left',
    },
  }
}

module.exports = (
  sliderStyle,
  {
    // named configuration options
    timeLabelColor, // color of time interval labels in the number line
    isNegative, // are you styling a 'negative' slider (looking back in time)
    isTops, // are you styling a slider for the tops build?
    isCustom,
    pillWidth, // width of the pill in px
  },
) => ({
  ...genBasicStyles({ isNegative, isTops, pillWidth, isCustom }),
  ...genNumberLineStyles({ color: timeLabelColor, isTops, isNegative }),
  ...prepareStyles(sliderStyle),
})



// WEBPACK FOOTER //
// ./src/components/Settings/styles/Sliders/generate-slider-styles.js